import React, { FC } from "react";

import { SubscriptionsSettingsSlide } from "./SubscriptionsSettingsSlide";
import ReportsProvider from "../../../../reportng/ReportsProvider";

import { ISubscriptionsSettingsSlideProps } from "./SubscriptionsSettingsSlide.types";
export const SubscriptionsSettingsSlideProvider: FC<ISubscriptionsSettingsSlideProps> = (props) => {
  const { value } = props;

  return (
    <div style={{ marginLeft: -8, minHeight: 51 }}>
      <ReportsProvider reportId={value.reportDefinition.id} subscriptionPayload={value}>
        <SubscriptionsSettingsSlide {...props} />
      </ReportsProvider>
    </div>
  );
};
